var _rect, _rect2, _rect3, _rect4, _rect5, _line, _rect6, _rect7, _path, _rect8, _rect9, _rect10, _rect11, _line2, _rect12, _rect13, _path2, _path3, _rect14, _rect15, _rect16, _path4, _rect17, _rect18, _path5, _rect19, _rect20, _rect21, _rect22, _path6, _rect23, _rect24, _path7, _circle, _line3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoHistoryData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 152 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 135.364,
    height: 99,
    x: 15.568,
    y: 1.25,
    fill: "#fff",
    stroke: "#E2E6EF",
    rx: 4.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12.467,
    height: 8.182,
    x: 31.324,
    y: 20.863,
    fill: "#E2E6EF",
    rx: 4.091
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 12.467,
    height: 8.182,
    x: 86.247,
    y: 20.863,
    fill: "#E2E6EF",
    rx: 4.091
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 12.467,
    height: 8.182,
    x: 108.715,
    y: 20.863,
    fill: "#E2E6EF",
    rx: 4.091
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 12.467,
    height: 8.182,
    x: 63.779,
    y: 20.863,
    fill: "#E2E6EF",
    rx: 4.091
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 29.649,
    x2: 136.85,
    y1: 14.954,
    y2: 14.954,
    stroke: "#E2E6EF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 8.182,
    height: 8.182,
    x: 53.649,
    y: 20.863,
    fill: "#9BD4B5",
    rx: 4.091
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 8.182,
    height: 8.182,
    x: 128.668,
    y: 20.863,
    fill: "#25E47A",
    rx: 4.091
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E2E6EF",
    d: "M102.2 27.4177L104.664 24.9541L102.2 22.4905L102.95 21.7407L106.163 24.9541L102.95 28.1675L102.2 27.4177Z"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 12.467,
    height: 8.182,
    x: 31.324,
    y: 39.863,
    fill: "#E2E6EF",
    rx: 4.091
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 12.467,
    height: 8.182,
    x: 86.247,
    y: 39.863,
    fill: "#E2E6EF",
    rx: 4.091
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 12.467,
    height: 8.182,
    x: 108.715,
    y: 39.863,
    fill: "#E2E6EF",
    rx: 4.091
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 12.467,
    height: 8.182,
    x: 63.779,
    y: 39.863,
    fill: "#E2E6EF",
    rx: 4.091
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 29.649,
    x2: 136.85,
    y1: 33.954,
    y2: 33.954,
    stroke: "#E2E6EF"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 8.182,
    height: 8.182,
    x: 53.649,
    y: 39.863,
    fill: "#9BD4B5",
    rx: 4.091
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 8.182,
    height: 8.182,
    x: 128.668,
    y: 39.863,
    fill: "#25E47A",
    rx: 4.091
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2E6EF",
    d: "M102.2 46.4177L104.664 43.9541L102.2 41.4905L102.95 40.7407L106.163 43.9541L102.95 47.1675L102.2 46.4177Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2E6EF",
    d: "M26.4316 62.9542C26.4316 60.6948 28.2632 58.8633 30.5226 58.8633H44.5585C46.8179 58.8633 48.6494 60.6948 48.6494 62.9542C48.6494 65.2135 46.8179 67.0451 44.5585 67.0451H30.5226C28.2632 67.0451 26.4316 65.2135 26.4316 62.9542Z"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 12.467,
    height: 8.182,
    x: 86.247,
    y: 58.863,
    fill: "#E2E6EF",
    rx: 4.091
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 12.467,
    height: 8.182,
    x: 108.715,
    y: 58.863,
    fill: "#E2E6EF",
    rx: 4.091
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 12.467,
    height: 8.182,
    x: 63.779,
    y: 58.863,
    fill: "#E2E6EF",
    rx: 4.091
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E2E6EF",
    d: "M45.6494 52.9541H136.85"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 8.182,
    height: 8.182,
    x: 53.649,
    y: 58.863,
    fill: "#9BD4B5",
    rx: 4.091
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 8.182,
    height: 8.182,
    x: 128.668,
    y: 58.863,
    fill: "#25E47A",
    rx: 4.091
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2E6EF",
    d: "M102.2 65.4177L104.664 62.9541L102.2 60.4905L102.95 59.7407L106.163 62.9541L102.95 66.1675L102.2 65.4177Z"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 12.467,
    height: 8.182,
    x: 31.324,
    y: 77.863,
    fill: "#E2E6EF",
    rx: 4.091
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 12.467,
    height: 8.182,
    x: 86.247,
    y: 77.863,
    fill: "#E2E6EF",
    rx: 4.091
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 12.467,
    height: 8.182,
    x: 108.715,
    y: 77.863,
    fill: "#E2E6EF",
    rx: 4.091
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 12.467,
    height: 8.182,
    x: 63.779,
    y: 77.863,
    fill: "#E2E6EF",
    rx: 4.091
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E2E6EF",
    d: "M46.6494 71.9541H136.85"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 8.182,
    height: 8.182,
    x: 53.649,
    y: 77.863,
    fill: "#9BD4B5",
    rx: 4.091
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 8.182,
    height: 8.182,
    x: 128.668,
    y: 77.863,
    fill: "#25E47A",
    rx: 4.091
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2E6EF",
    d: "M102.2 84.4177L104.664 81.9541L102.2 79.4905L102.95 78.7407L106.163 81.9541L102.95 85.1675L102.2 84.4177Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.742,
    cy: 62.874,
    r: 15.331,
    stroke: "#25E47A",
    strokeWidth: 5,
    transform: "rotate(38.1942 31.7422 62.8738)"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 20.852,
    x2: 3.995,
    y1: 76.411,
    y2: 97.836,
    stroke: "#25E47A",
    strokeLinecap: "round",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoHistoryData);
export default __webpack_public_path__ + "static/media/noHistoryData.53b7c6fc58f94162daa8647bf5238ea5.svg";
export { ForwardRef as ReactComponent };